import { forwardRef } from "react";
import styles from "./ArticleRelatedContentModule.module.scss";
import { gql } from "utils/urql";
import {
  ArticleRelatedContentModuleFragment,
  ArticleRelatedContentType,
  RecircServiceName,
} from "types/api";
import { useArticleContext } from "utils/articleContext";
import { useActiveTestGroup } from "utils/abTesting";

import ArticleRelatedContentRecommended from "components/article/ArticleRelatedContentRecommended";
import ArticleRelatedContentChannel from "components/article/ArticleRelatedContentChannel";
import ArticleRelatedContentMagazine from "components/article/ArticleRelatedContentMagazine";

const ArticleRelatedContentModule = forwardRef<
  HTMLDivElement,
  ArticleRelatedContentModuleFragment & { count: number }
>(function ArticleRelatedContentModule({ contentType, count }, ref) {
  const { articleId, primaryCategorySlug, previewParam } = useArticleContext();

  const testGroup1 = useActiveTestGroup("recirc-source");

  switch (contentType) {
    case ArticleRelatedContentType.Magazine:
      return (
        <div className={styles.root} ref={ref}>
          <ArticleRelatedContentMagazine
            id={articleId}
            preview={previewParam}
          />
        </div>
      );
    case ArticleRelatedContentType.Curated:
      let service = RecircServiceName.Ollie;
      if (testGroup1 === "recirc-source.datascience") {
        service = RecircServiceName.Datascience;
      }
      if (previewParam) {
        service = RecircServiceName.Parsely;
      }
      return (
        <div className={styles.root} ref={ref}>
          <div className={styles.notchedModule}>
            <ArticleRelatedContentRecommended
              id={articleId}
              service={service}
              count={count}
            />
          </div>
        </div>
      );
    case ArticleRelatedContentType.Channel:
      return (
        <div className={styles.root} ref={ref}>
          <div className={styles.notchedModule}>
            <ArticleRelatedContentChannel
              id={articleId}
              slug={primaryCategorySlug}
              count={count}
            />
          </div>
        </div>
      );
    case ArticleRelatedContentType.Editorialproject:
    case ArticleRelatedContentType.Category:
    default:
      // Any component in the article body must be an element
      // It's simpler to be consistent and have an empty element
      // than return null
      return <div ref={ref}></div>;
  }
});

ArticleRelatedContentModule.fragment = gql`
  fragment articleRelatedContentModule on ArticleRelatedContentModule {
    contentType
  }
`;

export default ArticleRelatedContentModule;
